import { createSlice } from "@reduxjs/toolkit"
import dashboardApiSlice from "services/dashboardApiSlice"
import moment from "moment"
import * as _ from "lodash"

const filter = (action) => {
  return [
    slice.actions.setLocationSelected.type,
    // slice.actions.setSourceSelected.type,
    slice.actions.setUserSelected.type,
    slice.actions.setFilteredSlugs.type,
  ].includes(action.type)
}

const initialState = {
  locations: {
    locationList: [],
    selected: [],
  },
  startDate: moment().subtract(5, "days").format("MM/DD/YYYY"),
  endDate: moment().format("MM/DD/YYYY"),
  sources: {
    sourceList: [],
    selected: ["google", 'medpromotor'],
    sourceMap: {},
  },
  selectedDepartments: [],
  selectedCategory: ["DEPARTMENT", "PROVIDER"],
  reviews: {
    reviewList: [],
    filteredList: [],
    hardRefresh: false,
    loading: false,
    filteredSlugs: [],
  },
  users: {
    userList: [],
    userMap: {},
    filteredList: [],
    selectedUser: "",
  },
}

const slice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setSourceSelected: (state, action) => {
      const source = action.payload
      state.sources.selected = source
    },
    setLocationSelected: (state, action) => {
      const locations = action.payload
      state.locations.selected = locations
    },
    setCategorySelected: (state, action) => {
      const categories = action.payload
      state.selectedCategory = categories
      if (!categories.length) state.selectedDepartments = []
    },
    setUserSelected: (state, action) => {
      if (state.users.selectedUser == action.payload)
        state.users.selectedUser = ""
      else state.users.selectedUser = action.payload
    },
    setStartEndDate: (state, action) => {
      state.startDate = action.payload.startDate
      state.endDate = action.payload.endDate
    },
    setSelectedDepartments: (state, action) => {
      state.selectedDepartments = action.payload
    },
    setReviewHardRefresh: (state, action) => {
      state.reviews.hardRefresh = action.payload
    },
    setDates: (state, action) => {
      state.startDate = action.payload.startDate
      state.endDate = action.payload.endDate
    },
    setFilteredSlugs: (state, action) => {
      state.reviews.filteredSlugs = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      dashboardApiSlice.endpoints.fetchReviews.matchFulfilled,
      (state, { payload }) => {
        state.reviews.reviewList = payload
        state.reviews.filteredList = payload
        state.reviews.loading = false
      }
    )
    builder.addMatcher(
      dashboardApiSlice.endpoints.fetchReviews.matchPending,
      (state, { payload }) => {
        state.reviews.loading = true
      }
    )
    builder.addMatcher(
      dashboardApiSlice.endpoints.fetchReviews.matchRejected,
      (state, { payload }) => {
        state.reviews.reviewList = []
        state.reviews.filteredList = []
        state.reviews.loading = false
      }
    )
    builder.addMatcher(
      dashboardApiSlice.endpoints.syncReview.matchFulfilled,
      (state, { payload }) => {
        state.reviews.loading = true
      }
    )
    builder.addMatcher(
      dashboardApiSlice.endpoints.syncReview.matchPending,
      (state, { payload }) => {
        state.reviews.loading = true
      }
    )
    builder.addMatcher(
      dashboardApiSlice.endpoints.syncReview.matchRejected,
      (state, { payload }) => {
        state.reviews.loading = false
      }
    )
    builder.addMatcher(
      dashboardApiSlice.endpoints.fetchLocations.matchFulfilled,
      (state, { payload }) => {
        state.locations.locationList = payload
      }
    )
    builder.addMatcher(
      dashboardApiSlice.endpoints.fetchLocations.matchRejected,
      (state, { payload }) => {
        state.locations.locationList = []
      }
    )
    builder.addMatcher(
      dashboardApiSlice.endpoints.fetchSourceList.matchFulfilled,
      (state, { payload }) => {
        state.sources.sourceList = payload
        payload?.forEach((item) => {
          state.sources.sourceMap[item.sourceName] = item.sourceImg
        })
      }
    )
    builder.addMatcher(
      dashboardApiSlice.endpoints.fetchSourceList.matchRejected,
      (state, { payload }) => {
        state.sources.sourceList = []
        state.sources.sourceMap = {}
      }
    )
    builder.addMatcher(
      dashboardApiSlice.endpoints.fetchUserListByLocation.matchFulfilled,
      (state, { payload }) => {
        state.users.userList = payload
        state.users.filteredList = payload
        state.users.userList?.forEach((user) => {
          state.users.userMap[user?._id] = user
        })
      }
    )
    builder.addMatcher(
      dashboardApiSlice.endpoints.fetchUserListByLocation.matchRejected,
      (state, { payload }) => {
        state.users.userList = []
        state.users.filteredList = []
        state.users.userMap = {}
      }
    )
    builder.addMatcher(filter, (state, action) => {
      if (state.locations.selected?.length) {
        state.users.filteredList = state.users.userList.filter((user) => {
          return state.locations.selected.includes(user.locationId)
        })
      }
      //if location length is zero
      else state.users.filteredList = state.users.userList

      // if (state.sources.selected?.length) {
      //   state.reviews.filteredList = state.reviews.reviewList.filter(
      //     (review) => {
      //       return state.sources.selected.includes(review.source)
      //     }
      //   )
      // } else state.reviews.filteredList = state.reviews.reviewList

      if (state.users.selectedUser) {
        state.reviews.filteredList = state.reviews.reviewList.filter((review) =>
          state.reviews.filteredSlugs.includes(review.slug)
        )
      }
    })
  },
})

export default slice.reducer
export const {
  setSourceSelected,
  setLocationSelected,
  setUserSelected,
  setStartEndDate,
  setSelectedDepartments,
  setReviewHardRefresh,
  setDates,
  setCategorySelected,
  setFilteredSlugs,
} = slice.actions
